import React from "react";
import PropTypes from "prop-types";
import "./style.scss";
import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";
import { useFormContext } from "react-hook-form";

function Bodycopy({ bodyCopy }) {
  const { getValues } = useFormContext();
  const { translate: t } = useLanguageProvider();

  const paymentRecipientType = getValues("paymentRecipientType");
  const title = bodyCopy?.title({ t });
  const body = bodyCopy?.body?.({ t, paymentRecipientType });
  return (
    <div className="bodycopy">
      <div className="title">{title}</div>

      <div className="body">{body}</div>
    </div>
  );
}

Bodycopy.propTypes = {
  bodyCopy: PropTypes.shape({
    title: PropTypes.func,
    body: PropTypes.func,
  }),
};

export default Bodycopy;
